/* src/locations/actions.js */

import {
  FETCH_LOCATIONS,
  FETCH_LOCATIONS_SUCCESS,
  FETCH_LOCATIONS_FAIL,
  ADD_LOCATION,
  ADD_LOCATION_SUCCESS,
  ADD_LOCATION_FAIL,
  addLocationToUniversityTypes,
  addInterviewLocationTypes,
  editLocationTypes,
  removeLocationTypes,
} from './action_types';

import { makeMutation, makeQuery } from '../../config/client';
import {
  LOCATIONS_QUERY,
  ADD_LOCATION_MUTATION,
  ADD_LOCATION_TO_UNIVERSITY_MUTATION,
  ADD_INTERVIEW_LOCATION_MUTATION,
  EDIT_LOCATION_MUTATION,
  REMOVE_LOCATION_MUTATION,
} from './api';

const fetchLocationsTypes = [
  FETCH_LOCATIONS,
  FETCH_LOCATIONS_SUCCESS,
  FETCH_LOCATIONS_FAIL,
];

/**
 * @param {Object} input - necessary location input
 * @param {Object} input.input - necessary location input
 * @param {Array<string>} input.input.universities - list of university ids.
 * @param {Array<string>} input.input.types - list of location types. should be
 *   ['CAFE', 'UNIVERSITY']
 * @param {number} input.input.radius - radius in meters.
 * @return {array} - array of locations.
 */
export const fetchLocations = input => makeQuery(input)(
  fetchLocationsTypes,
  LOCATIONS_QUERY,
);

const addLocationTypes = [
  ADD_LOCATION,
  ADD_LOCATION_SUCCESS,
  ADD_LOCATION_FAIL,
];

/**
 * @param {Object} input - necessary location input
 * @param {Object} input.input - necessary location input
 * @param {string} input.input.name - name of the location.
 * @param {string} input.input.address - address of the location.
 * @param {string} input.input.city - city of the location.
 * @param {string} input.input.type - type of the location.
 * @param {Object} input.input.coordinates - coordinates of the location.
 * @param {number} input.input.coordinates.longitude - longitude of coordinates.
 * @param {number} input.input.coordinates.latitude - latitude of coordinates.
 * @return {array} - array of locations.
 */
export const addLocation = input => makeMutation({ variables: input })(
  addLocationTypes,
  ADD_LOCATION_MUTATION
);

export const addLocationToUniversity = variables => makeMutation({ variables })(
  addLocationToUniversityTypes,
  ADD_LOCATION_TO_UNIVERSITY_MUTATION
);

export const addInterviewLocation = variables => makeMutation({ variables })(
  addInterviewLocationTypes,
  ADD_INTERVIEW_LOCATION_MUTATION
);

/**
 * @param {Object} variables - variables to pass into the mutation.
 * @param {string} variables.location - location id.
 * @param {Object} variables.updateLocationInput - UpdateLocationInput!
 * @returns {function} - function to edit a location.
 */
export const editLocation = variables => makeMutation({ variables })(
  editLocationTypes,
  EDIT_LOCATION_MUTATION
);

/**
 * @param {Object} variables - variables to pass into the mutation.
 * @param {sring} variables.location - location id.
 */
export const removeLocation = variables => makeMutation({ variables })(
  removeLocationTypes,
  REMOVE_LOCATION_MUTATION
);



// WEBPACK FOOTER //
// ./src/modules/locations/actions.js